import R from 'app/assets/R'
import { ButtonCreate } from 'app/components/common/ButtonCreate'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { PROFILE_MANAGEMENT_CREATE_PATH } from 'app/components/router/route-path'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import * as S from 'app/components/tables/BaseTableManagement/styles'
import { t } from 'i18next'
import FilterLayout from './components/Filter'
import { useHookTable } from './hook'
const ProfileManagementContainer = () => {
  const {
    tableData,
    columns,
    handleTableChange,
    filter,
    handleChangeFilter,
    handleExport,
  } = useHookTable()

  return (
    <S.BaseManagementWrapper>
      <HeaderPage
        titleI18nKey={R.strings.profile_content_management}
        isExport
        onPressExport={handleExport}
        rightComponent={
          <ButtonCreate
            title={t(R.strings.profile_content_add)}
            path={PROFILE_MANAGEMENT_CREATE_PATH}
          />
        }
      />
      <S.RootWrapper>
        <FilterLayout onChangeFilter={handleChangeFilter} filter={filter} />
        <BaseTableManagement
          columns={columns}
          dataSource={tableData.data}
          pagination={tableData.pagination}
          loading={tableData.isLoading}
          onChange={handleTableChange}
        />
      </S.RootWrapper>
    </S.BaseManagementWrapper>
  )
}
export default ProfileManagementContainer
